
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/user/welcome",
      function () {
        return require("private-next-pages/user/welcome.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/user/welcome"])
      });
    }
  